export default __webpack_public_path__ + "static/media/dporn-2-l.4046cd63.png";